import { Injectable } from '@angular/core';
import { OfflineFeedService } from './offline-feed.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { OfflineStates } from '../../enums/offline-states';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root'
})

export class OfflineService {
  isOffline = false;
  isOfflineCapable = false;
  state: OfflineStates = OfflineStates.UP_TO_DATE;
  updateProgress = 0;

  private _offlineEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private _stateEvent: BehaviorSubject<OfflineStates> = new BehaviorSubject<OfflineStates>(null);

  public readonly offlineEvent$: Observable<boolean> = this._offlineEvent.asObservable();
  public readonly stateEvent$: Observable<string> = this._stateEvent.asObservable();

  constructor(
    private offlineFeedService: OfflineFeedService,
    private platformService: PlatformService
  ) {
    this._stateEvent.next(this.state);
    this._offlineEvent.next(this.isOffline);
    this.isOfflineCapable = platformService.isOfflineCapable();
    this.offlineFeedService.isActivated().subscribe();
  }

  changeIsOffline(isOffline: boolean): void {
    this.isOffline = isOffline;
    this._offlineEvent.next(isOffline);
  }

  setstateEvent(state: OfflineStates) {
    this.state = state;
    this._stateEvent.next(this.state);
  }

  setUpdateProgress(progress: number) {
    this.updateProgress = progress;
  }
}
